import { createContext } from "react";

const nccdContext = createContext();

export default nccdContext;
